<template>
    <nav class="navbar navbar-expand-lg">
        <div class="container-xl">
            <div class="navbar-brand d-flex align-items-center p-0">
                <router-link to="/">
                    <img src="/wp-content/themes/thelane/logo.svg" alt="The Lane Agency Portfolio logo" width="105" height="89" class="logo">
                </router-link>
            </div>
            <button class="navbar-toggler border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse ms-auto d-lg-flex justify-content-center">
                <ul class="nav justify-content-center">
                    <li class="nav-item" v-for="item in menu">
                      <router-link :to="item.url" active-class="active" class="nav-link d-flex justify-content-center align-items-center">
                        <span v-html="item.title"></span>
                      </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <div role="main" class="main">
      <div class="container-xl">
        <router-view></router-view>
      </div>
    </div>
    <footer class="container pt-3 pb-3 d-flex justify-content-center d-md-none"></footer>
    <div class="offcanvas offcanvas-end" ref="offcanvas" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
      <div class="offcanvas-header">
        <h5 id="offcanvasRightLabel" class="m-0">Menu</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body pt-5">
        <ul class="nav align-items-end d-flex flex-column">
          <li class="nav-item" v-for="item in menu" data-bs-dismiss="offcanvas">
            <router-link :to="item.url" active-class="active" class="nav-link d-flex justify-content-center align-items-center">
              <span v-html="item.title" class="h3"></span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
</template>
<script>
import Offcanvas from 'bootstrap/js/dist/offcanvas';

export default {
  data() {
    return {
      menu: [],
      loading: false,
      loaded: false,
      error: '',
      clientVersion: null,
      navBar: null
    }
  },
  created() {
    this.loading = true;
    this.clientVersion = localStorage.getItem('clientVersion');
    let self = this;
    axios.interceptors.response.use(function (response) {
      /**
       * This is automatically called after every successful Axios request (any
       * status code that lie within the range of 2xx).
       *
       * We check the returned client version number against our stored version
       * and reload the app if it has changed.
       */
      self.checkVersion(response.headers['x-client-version']);
      return response;
    });
  },
  mounted() {
    this.loadMenu();
    new Offcanvas(this.$refs.offcanvas);
    this.navBar = document.querySelector(".navbar");
    window.onscroll = this.checkScroll;
  },
  methods: {
    loadMenu() {
      try {
        const that = this;
        axios.get("/wp-json/menus/v1/menus/12")
          .then(function(response) {

            that.menu = response.data;

            that.loaded = true;
            that.loading = false;

            that.error = '';

          });
      }
      catch(error) {
        this.error = 'Data could not be loaded.';
      }
    },
    checkVersion(version) {
      let shouldUpdateClientVersion = false;
      let shouldReloadClient = false;

      if (!this.clientVersion) {
        // We do not have a clientVersion stored, so we should set it for the first time
        shouldUpdateClientVersion = true;
      }
      else if (this.clientVersion !== version) {
        // We have a clientVersion stored and it does not match the new client version. Reload.
        shouldUpdateClientVersion = true;
        shouldReloadClient = true;
      }
      else {
        // Our stored clientVersion matches the current value. This might happen on initial page load. Do nothing.
      }

      if (shouldUpdateClientVersion) {
        localStorage.setItem('clientVersion', version);
      }
      if (shouldReloadClient) {
        //window.location.reload(true);
      }
    },
    checkScroll() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        this.navBar.classList.add('reduce');
      }
      else {
        this.navBar.classList.remove('reduce');
      }
    }
  }
}
</script>
